<script setup lang="ts">
import { ref } from 'vue';
import useLocale from '../helpers/use-locale';

type Emits = {
  (e: 'clickAdd'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  label?: string;
};
defineProps<Props>();

const { t } = useLocale();
const isLoading = ref(false);
const handleClick = () => {
  isLoading.value = true;
  emit('clickAdd');
};
</script>

<template>
  <v-btn color="tertiary-container" size="x-small" icon :loading="isLoading" :aria-label="label" @click="handleClick">
    <v-icon>mdi-plus</v-icon>
    <v-tooltip activator="parent" :text="t('components.add_button')" location="top" />
  </v-btn>
</template>

<style scoped lang="scss"></style>
